export class CieSubject {
  subjectCode: string;
  subjectName: string;
  testComponent: string;
  include?: boolean;

  constructor(subjectCode = '', subjectName = '', testComponent = '', include = false) {
    this.subjectCode = subjectCode;
    this.subjectName = subjectName;
    this.testComponent = testComponent;
    this.include = include;
  }

  equals(other: CieSubject) {
    return this.subjectCode === other.subjectCode && this.testComponent === other.testComponent;
  }
}

export class CieGrade {
  academicLevel: string;
  rankScore: number;
  result: string;
  subjectUnit: number;

  constructor(academicLevel = '', rankScore = 0, result = '', subjectUnit = 0) {
    this.academicLevel = academicLevel;
    this.rankScore = rankScore;
    this.result = result;
    this.subjectUnit = subjectUnit;
  }

  equals(other: CieGrade) {
    return this.academicLevel === other.academicLevel && this.result === other.result;
  }
}

export interface CieSubjectGrades extends CieSubject {
  results: CieGrade[];
}

export class CieChosenSubjectGrade {
  subject: CieSubject;
  grade: CieGrade;
  gradesList: CieGrade[];

  constructor(subject: CieSubject = new CieSubject(), grade: CieGrade = new CieGrade(), gradesList = []) {
    this.subject = subject;
    this.grade = grade;
    this.gradesList = gradesList;
  }

  equals(other: CieChosenSubjectGrade) {
    return this.subject === other.subject;
  }
}

export class CalculationRequestSubjects {
  testComponent: string;
  subjectCode: string;
  academicLevel: string;
  result: string;

  constructor(testComponent: string, subjectCode: string, academicLevel: string, result: string) {
    this.testComponent = testComponent;
    this.subjectCode = subjectCode;
    this.academicLevel = academicLevel;
    this.result = result;
  }
}
